import { render, staticRenderFns } from "./DisplayContent.vue?vue&type=template&id=3432da37&scoped=true&"
import script from "./DisplayContent.vue?vue&type=script&lang=js&"
export * from "./DisplayContent.vue?vue&type=script&lang=js&"
import style0 from "./DisplayContent.vue?vue&type=style&index=0&id=3432da37&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3432da37",
  null
  
)

export default component.exports